export default __webpack_public_path__ + "static/media/group.b7af8500.svg";